import {
    Box,
    TextField,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Grid,
    InputAdornment,
    IconButton,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

// Rendert den Formularinhalt des jeweiligen Registrierungsschritts.
function RegisterStepContent({ step, formData, onChange, showPassword, setShowPassword }) {
    switch (step) {
        case 0:
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <TextField
                        label="E-Mail"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={onChange}
                        fullWidth
                        required
                        autoComplete="email"
                        inputProps={{ maxLength: 50 }}
                    />
                    <TextField
                        label="Passwort"
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        value={formData.password}
                        onChange={onChange}
                        fullWidth
                        required
                        autoComplete="new-password"
                        InputProps={{
                            maxLength: 50,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Passwort bestätigen"
                        type={showPassword ? 'text' : 'password'}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={onChange}
                        fullWidth
                        required
                        autoComplete="new-password"
                        inputProps={{ maxLength: 50 }}
                    />
                </Box>
            );
        case 1:
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <Grid container spacing={2}>
                        <Grid>
                            <TextField
                                label="Vorname"
                                name="vname"
                                value={formData.vname}
                                onChange={onChange}
                                fullWidth
                                required
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid>
                            <TextField
                                label="Nachname"
                                name="nname"
                                value={formData.nname}
                                onChange={onChange}
                                fullWidth
                                required
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                    </Grid>
                    <TextField
                        label="Geburtsdatum"
                        type="date"
                        name="geb_datum"
                        value={formData.geb_datum}
                        onChange={onChange}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                    <FormControl fullWidth>
                        <InputLabel>Geschlecht</InputLabel>
                        <Select
                            name="geschlecht"
                            value={formData.geschlecht}
                            onChange={onChange}
                            label="Geschlecht"
                        >
                            <MenuItem value="m">Männlich</MenuItem>
                            <MenuItem value="w">Weiblich</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            );
        case 2:
            return (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Optional - kann später ergänzt werden
                    </Typography>
                    <Grid container spacing={2} sx={{ width: "100%" }}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField
                                label="Gewicht (kg)"
                                type="number"
                                name="gewicht"
                                value={formData.gewicht}
                                onChange={onChange}
                                fullWidth
                                inputProps={{ maxLength: 50, step: "0.1", min: 0, max: 500 }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField
                                label="Zielgewicht (kg)"
                                type="number"
                                name="ziel_gewicht"
                                value={formData.ziel_gewicht}
                                onChange={onChange}
                                fullWidth
                                inputProps={{ maxLength: 50, step: "0.1", min: 1, max: 500 }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField
                                label="Größe (cm)"
                                type="number"
                                name="groesse"
                                value={formData.groesse}
                                onChange={onChange}
                                fullWidth
                                inputProps={{ min: 0, max: 250, maxLength: 50 }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            );
        default:
            return null;
    }
}

export default RegisterStepContent;
